import { useEffect, useRef } from "react";

interface IProps {
  listSize: number | null;
  listMinSize: number;
  targetOrder: string;
  currentOrder: string;
  alternativeOrder: string;
  changeOrder: (value: string) => void;
}

export const useListAlternativeOrder = (props: IProps) => {
  const {
    listSize,
    listMinSize,
    targetOrder,
    currentOrder,
    alternativeOrder,
    changeOrder
  } = props;
  const alternativeOrderApplied = useRef<boolean>(false);

  useEffect(() => {
    if (
      listSize !== null
      && listSize < listMinSize
      && currentOrder === targetOrder
      && !alternativeOrderApplied.current
    ) {
      changeOrder(alternativeOrder);
      alternativeOrderApplied.current = true;
    }
  }, [listSize, listMinSize, currentOrder, alternativeOrder]);
};
